document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.getElementById('mobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
  }

  const crest = document.querySelector('[data-hero-crest]');

  if (crest) {
    const hoverSoundUrl = crest.dataset.hoverSoundUrl;
    if (hoverSoundUrl) {
      const hoverSound = new Audio(hoverSoundUrl);
      hoverSound.preload = 'auto';
      hoverSound.volume = 1;

      const playHoverSound = () => {
        try {
          hoverSound.pause();
          hoverSound.currentTime = 0;
          const playAttempt = hoverSound.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {});
          }
        } catch (_) {}
      };

      crest.addEventListener('pointerenter', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        playHoverSound();
      });
    }
  }

  if (crest && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    window.addEventListener('pointermove', (event) => {
      if (window.innerWidth < 980) return;
      const x = event.clientX / window.innerWidth - 0.5;
      const y = event.clientY / window.innerHeight - 0.5;
      crest.style.transform = `rotateY(${x * 8}deg) rotateX(${y * -7}deg) translate3d(${x * 12}px, ${y * 12}px, 0)`;
    });
    window.addEventListener('pointerleave', () => {
      crest.style.transform = '';
    });
  }
});
